import React, { PureComponent, useEffect,useState } from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from 'recharts';


const configGrafica = [
  {
    subject: 'Fragancia / aroma',
    column: 'fragancia_aroma',
    valor: 0,
  },
  {
    subject: 'Sabor',
    column: 'sabor',
    valor: 0,
  },
  {
    subject: 'Sabor residual',
    column: 'sabor_residual',
    valor: 0,
  },
  {
    subject: 'Acidez',
    column: 'acidez',
    valor: 0,
  },
  {
    subject: 'Sensación en boca',
    column: 'cuerpo',
    valor: 0,
  },
  {
    subject: 'Balance',
    column: 'balance',
    valor: 0,
  },
  {
    subject: 'Uniformidad',
    column: 'uniformidad',
    valor: 0,
  },
  {
    subject: 'Taza limpia',
    column: 'taza_limpia',
    valor: 0,
  },
  {
    subject: 'Dulzor',
    column: 'dulzor',
    valor: 0,
  },
  {
    subject: 'Catador',
    column: 'catador',
    valor: 0,
  }
];

const GraficaSensorial = ({data, width, height}) => {
  const [dataGrafica, setDataGrafica] = useState(configGrafica);
  useEffect(() => {
    // Clona la configuración para evitar mutaciones compartidas
    const _configGrafica = configGrafica.map(item => ({ ...item, valor: 0 }));
    let suma = 0;
    let uniformidad = 0;
    let dulzor = 0;
    let tazaLimpia = 0;
    let defectosNoTazas = 0;
    let defectosIntensidad = 0;
    for (let c = 0; c < _configGrafica.length; c++) {
      const key = _configGrafica[c].column;
      const val = data && typeof data[key] !== 'undefined' ? Number(data[key]) : 0;
      // Para la gráfica, ponderar Uniformidad y Dulzor a escala 0-10
      if (key === 'uniformidad' || key === 'dulzor' || key === 'taza_limpia') {
        _configGrafica[c].valor = isNaN(val) ? 0 : (val * 2);
      } else {
        _configGrafica[c].valor = isNaN(val) ? 0 : val;
      }
      if (key === 'uniformidad') uniformidad = isNaN(val) ? 0 : val;
      else if (key === 'dulzor') dulzor = isNaN(val) ? 0 : val;
      else if (key === 'taza_limpia') tazaLimpia = isNaN(val) ? 0 : val;
      else suma += isNaN(val) ? 0 : val; // incluye todos los atributos
    }
    // Defectos desde data (no forman parte de la gráfica)
    defectosNoTazas = data && typeof data['defectos_no_tazas'] !== 'undefined' ? Number(data['defectos_no_tazas']) : 0;
    defectosIntensidad = data && typeof data['defectos_intensidad'] !== 'undefined' ? Number(data['defectos_intensidad']) : 0;
    setDataGrafica(_configGrafica);
  },[data]);

    return (
      <>
        <RadarChart
          width={width || Math.floor(window.innerWidth / 2.5)}
          height={height || Math.floor(window.innerWidth / 2.5)}
          cx="50%"
          cy="50%"
          outerRadius="75%"
          data={dataGrafica}
        >
          <PolarGrid />
          <PolarAngleAxis dataKey="subject" />
          <PolarRadiusAxis angle={90} domain={[0, 10]} />
          <Radar max={10} min={6} animationDuration={500} dot={true} name="Análisis sensorial" dataKey="valor" stroke="#C7AE34" fill="#C7AE34" fillOpacity={0.6} />
        </RadarChart>
      </>
    );
}

export default GraficaSensorial;
